export const getActualFlightDetails = ({flightSegment}) => {
    const startFlight = flightSegment?.legs[0];
    const lastLegIndex = flightSegment?.legs?.length - 1;
    const endFlight = flightSegment?.legs[lastLegIndex];
    return {startFlight, endFlight};
}

export const getEstimateTimeFormat = estimateTime => {
    let text = (f, s) =>
        estimateTime?.substring(
            estimateTime.indexOf(f) + 1,
            estimateTime?.lastIndexOf(s),
        );
    if (!estimateTime?.includes('H')) {
        return `${text('T', 'M')}m`;
    } else if (!estimateTime?.includes('M')) {
        return `${text('T', 'H')}h`;
    }
    return `${text('T', 'H')}h ${text('H', 'M')}m`;
};

export const getTotalStops = (stops, T) => {
    if (stops === '0') {
        return T('Packages_Detail:Non_Stops');
    } else if (stops === '1') {
        return `${stops} ${T('Packages_Detail:Stop')}`;
    } else {
        return `${stops} ${T('Packages_Detail:Stops')}`;
    }
};
